import React, { useContext, useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import "./Login.scss";

import { withTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import Ecodrisil_logoExpress from "../../../src/images/Ecodrisil_express_esg_logo.webp";
import Ecodrisil_logoExpressDrak from "../../../src/images/Ecodrisil_express_esg_logo_Dark.webp";
import { CompanyContext, LoaderContext, RegulationContext, UserContext } from "../../App";
import ThemesToggleBox from "../../ThemesToggle";
import {
  SUPER_ADMIN_TXT
} from "../../core/constants/api";
import { LS_AUTHORITY_KEY,LS_AI_CONFIG_KEY, LS_TERMS_AGREED_KEY, LS_UI_ELEMENTS_CONFIG_KEY, USER_ROLE } from "../../core/constants/common";
import AICopilotConfigService from "../../core/service/AICopilotConfigService";
import {
  COMPLETED_TXT,
  ONBOARD_TXT,
  SUPPLIER_DETAILS_TXT,
} from "../../core/service/CommonService";
import PartnerService from "../../core/service/PartnerService";
import LoginService from "../../core/service/login-service";
import PermissionUtils from "../../core/utilities/PermissisonUtils";
import { hasGoalsKpiNavAccess } from "../SubscriberSupplierAdmin/GoalsAndKpi/utils/goalsAndKpiNavAccess";
import { buildHierarchyPermissions } from "../SubscriberSupplierAdmin/GoalsAndKpi/utils/hierarchyPermissions";
import { BsEye, BsEyeSlash } from "react-icons/bs";

const Login = ({ t }) => {
  const navigate = useNavigate();
  const userRef = useRef();

  const [user, setUser] = useState("");
  const [password, setPwd] = useState("");
  const [errorMsg, setErrMsg] = useState("");
  const [rememberChecked, setRememberChecked] = useState(false);
  const { setGlbRegulation } = useContext(RegulationContext);
  const { setGlbCompany } = useContext(CompanyContext);
  const [validated, setValidated] = useState(false);
  const { setUserDetails } = useContext(UserContext);
  const { setLoaderDisplay } = useContext(LoaderContext);
  const [searchParams] = useSearchParams();

  const uiElementsConfig = JSON.parse(localStorage.getItem(LS_UI_ELEMENTS_CONFIG_KEY)) ?? null;

  useEffect(() => {
    if (uiElementsConfig?.texts?.appTitle) {
      // Updates browser tab title
      document.title = uiElementsConfig?.texts?.appTitle;
    }
    let rememberVal = localStorage.getItem('rememberMe');
    let jwtToken = localStorage.getItem('accessToken');
    if (rememberVal && jwtToken) {
      var data = JSON.parse(localStorage.getItem("authority"));
      const companyId = data.profile.company.id;
      profileCompletion(companyId, data.roles);
    } else {
      userRef.current.focus();
    }


  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [user, password]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidated(true);
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      return;
    }
    
    setLoaderDisplay(true);
    setErrMsg("");
    
    var obj = {
      username: user,
      password: password,
      rememberMe: rememberChecked
    };
    LoginService.login(obj)
      .then((response) => {
        setGlbRegulation({});
        setGlbCompany({});
        let responseData = response.data;
        if (responseData.status === 200) {
          localStorage.setItem("accessToken", responseData.data.accessToken);
          rememberChecked && localStorage.setItem("rememberMe", rememberChecked);
          checkLoginAuthority();
        } else {
          setLoaderDisplay(false);
          setErrMsg(responseData.message || "Login failed");
        }
      })
      .catch((error) => {
        setLoaderDisplay(false);
        setErrMsg("Login failed. Please check your credentials.");
      });
  };

  const checkLoginAuthority = async (e) => {
    LoginService.checkAuthority()
      .then((response) => {
        let responseData = response.data.data;
        if (response.status === 200) {
          setUserDetails(responseData);
          localStorage.setItem(LS_AUTHORITY_KEY, JSON.stringify(responseData));
          localStorage.setItem(LS_TERMS_AGREED_KEY, responseData?.profile?.user?.termsAgreed ?? true);
       //   if (responseData.roles.indexOf(SUPER_ADMIN_TXT) > -1) {
          if(PermissionUtils.isSuperAdmin(responseData.roles)) {
            setLoaderDisplay(false);
            navigate("/admin/");
          } else if (PermissionUtils.isConsultant(responseData.roles)) {
            setLoaderDisplay(false);
            navigate("/consultant/switch/");
          } else {
            if (responseData?.profile?.company) {
              profileCompletion(responseData.profile.company.id, responseData.roles);
            } else {
              profileCompletion(0, responseData?.roles);
            }
          }
          fetchUIElementsConfig(responseData?.profile?.user);
          fetchCompanyAICopilotConfig();
        } else {
          setLoaderDisplay(false);
          setErrMsg("Authentication failed");
        }
      })
      .catch((error) => {
        setLoaderDisplay(false);
        setErrMsg("Authentication failed. Please try again.");
      });
  };

  const profileCompletion = async (companyId, roles = []) => {
    LoginService.profileComplete(companyId)
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem(
            "userOnboardData",
            JSON.stringify(response.data)
          );
        //  if (roles.indexOf(SUPER_ADMIN_TXT) > -1) {
        if(PermissionUtils.isSuperAdmin(roles)) {
            setLoaderDisplay(false);
            navigate("/admin/");
          } else if(roles?.length > 0){
            if (response?.data?.pendingInvitations?.length > 0) {
              setLoaderDisplay(false);
              navigate("/company_admin/pending_invitations");
            } else {
              var nextStep = response.data.nextStep;
              switch (nextStep) {
                case ONBOARD_TXT:
                  setLoaderDisplay(false);
                  navigate(
                    "/company_admin/company_onboard/" + response.data.key
                  );
                  break;
                case SUPPLIER_DETAILS_TXT:
                  setLoaderDisplay(false);
                  navigate(
                    "/company_admin/supplier_details_onboard/" +
                    response.data.connectedCompany.companyId +
                    "/" +
                    response.data.connectedCompany.supplierDetails.id
                  );
                  break;
                case null:
                case COMPLETED_TXT:
                default: {
                  setLoaderDisplay(false);
                  const redirectParam = searchParams.get('redirect');
                  const period = searchParams.get('period');
                  if (redirectParam === 'qualitative') {
                    navigate(`/company_admin/qualitative${period ? `?period=${period}` : ''}`);
                  } else if (
                    // TEMPORARY: same Goals & KPI nav check as the sidebar. Land on Goals & KPI dashboard. Revisit soon.
                    hasGoalsKpiNavAccess(buildHierarchyPermissions(Array.isArray(roles) ? roles : []))
                  ) {
                    navigate("/company_admin/goals_kpi/dashboard");
                  } else {
                    navigate("/company_admin/");
                  }
                  break;
                }
              }
            }
          }
        } else {
          setLoaderDisplay(false);
          setErrMsg("Profile completion failed");
        }
      })
      .catch((error) => {
        setLoaderDisplay(false);
        setErrMsg("Profile completion failed. Please try again.");
      });
  };
  const handleRememberChecked = (event) => {
    let val = event.currentTarget.checked;
    setRememberChecked(val);
  };

  const fetchUIElementsConfig = (userData) => {
    if (!userData.partnerId) {
      localStorage.setItem(LS_UI_ELEMENTS_CONFIG_KEY, null);
      return;
    }
    PartnerService.getPartnerSpecificUIConfig(userData.partnerId).then(res => {
      localStorage.setItem(LS_UI_ELEMENTS_CONFIG_KEY, null);
      if (res.status !== 200) return;

      localStorage.setItem(LS_UI_ELEMENTS_CONFIG_KEY, res.data ? JSON.stringify(res.data) : null);
    }).catch(err => {
      localStorage.setItem(LS_UI_ELEMENTS_CONFIG_KEY, null);
    });
  };

  const [showPassword, setShowPassword] = useState(false);
  // const [password, setPassword] = useState('');

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const fetchCompanyAICopilotConfig = () => {
    AICopilotConfigService.getActiveConfig().then(res => {
      if (res.status !== 200) return;

      localStorage.setItem(LS_AI_CONFIG_KEY, JSON.stringify(res.data?.config ?? {}));
    }).catch(err => { });
  };
  const currentYear = new Date().getFullYear();
  return (
    <section className="Login_page_section" >
      {/* <div className="row m-0">
        <div className="col-lg-6 col-md-6 p-0 Login_leftBox">
          <div className="Login_leftBox_Logo">
            <img src={Lognin_logo} />
          </div>
        </div>
        <div className="col-lg-6 col-md-6 p-0 Login_RightBox"> */}
      <div className="Login_Form">
        <div className="Switch_Themes_mode_login">
          <ThemesToggleBox />
        </div>
        <div className="Login_Form_in">
          <div className="text-center p-3 pb-2">
            <img className="light_logo" src={Ecodrisil_logoExpress} />
            <img className="Drak_logo" src={Ecodrisil_logoExpressDrak} />
          </div>
          <div className="mb-4 Login_Form_in_head text-center">
            {/* <h3> {t("login.label")}</h3> */}
            <p>{t("welcomeBack.label")}</p>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="mb-4">
              <div className="mb-3">
                <label className="mb-1">{t("Emailid.label")}</label>
                <input
                  type="email"
                  className="form-control"
                  id="username"
                  ref={userRef}
                  autoComplete="off"
                  onChange={(e) => setUser(e.target.value)}
                  value={user}
                  required
                  aria-describedby="emailHelp"
                />
              </div>
              <div className="mb-3 login_password">
                <label
                  htmlFor="exampleInputPassword1"
                  className="mb-1"
                >
                  {t("password.label")}
                </label>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  id="password"
                  autoComplete="off"
                  onChange={(e) => setPwd(e.target.value)}
                  value={password}
                  required
                />
                <span onClick={togglePasswordVisibility}>
                  <BsEye className={showPassword ? 'd-none' : ''}/>
                  <BsEyeSlash className={showPassword ? '' : 'd-none'}/>
                </span>
              </div>
              <div className="pb-2 form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="exampleCheck1"
                  checked={rememberChecked}
                  onChange={handleRememberChecked}
                />
                <label className="form-check-label" htmlFor="exampleCheck1">
                  {t("rememberPassword.label")}
                </label>
                {/* <button type="button" className="btn btn-link w-100" onClick={() => {
                          navigate(`/forgot_password`);
                        }}>
                      {t("forgotPassword.label")}
                    </button> */}
                <a className="Forgot_pass" href="/forgot_password">
                  {t("forgotPassword.label")}
                </a>
              </div>
            </div>
            <button type="submit" className="btn btn-primary w-100 sbmBtn">
              {t("submit.label")}
            </button>
            {/* <div className="py-2 mt-3 text-center">
                  <p>{t("noAccount.label")} <a href="/sign_up">{t("signup.label")}</a></p>
                </div> */}
          </Form>
          <div className="Login_Privacy_TermsBox01">
            <ul>
              <li><a target="_blank" href="https://ecodrisil.com/privacy-policy">Privacy Policy</a></li>
              <li><a target="_blank" href="https://ecodrisil.com/terms-of-use">Terms of Use</a></li>
            </ul>
          </div>
          <div className="text-center">
            {uiElementsConfig?.texts?.footer ?? `©${currentYear} ${t("EcodrisilAllRightsReserved.label")}`}
          </div>
        </div>
      </div>
      {/* </div>
      </div> */}
    </section>
  );
};

export default withTranslation()(Login);
